import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { ApprovalWrapper } from "./ApprovalStyled";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import IndeterminateCheckBoxIcon from "@mui/icons-material/IndeterminateCheckBox";
import CloseIcon from "@mui/icons-material/Close";
import { QuoteStatus, UserRole } from "../../QuoteRequest/Content";
import { Button } from "@mui/material";

const createData = (approver, status, iconClassName) => ({
  approver,
  status,
  iconClassName,
});

const roleLabels = {
  [UserRole.PRICINGTEAM]: "Pricing Team",
  [UserRole.SAMLEADERSHIPTEAM]: "SAM Leadership Team",
  [UserRole.PRICINGMANAGER]: "Pricing Manager",
  [UserRole.PRICINGVP]: "Pricing VP",
  [UserRole.SAMLEADERSHIPTEAMLEVEL3]: "CRO",
};

const Approval = ({ approvalAssignments = [], handleAssignApprover = () => {}, quoteStatus }) => {
  const rows = [...approvalAssignments]
    .sort((a, b) => new Date(a.createdDate) - new Date(b.createdDate))
    .map((a) => {
    if (a.isRejected)
      return createData(
        roleLabels[a.approverRoleId],
        "Rejected",
        "custom-close-icon",
      );

    if (a.isApproved)
      return createData(
        roleLabels[a.approverRoleId],
        "Completed",
        "custom-check-icon",
      );

    return createData(
      roleLabels[a.approverRoleId],
      "Pending Approval",
      "custom-cancel-icon",
    );
    });

  const areAllApproved =
  approvalAssignments.length > 0 &&
  approvalAssignments.every((a) => a.isApproved === true);

  return (
    <ApprovalWrapper>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Approver</TableCell>

              <TableCell>Status</TableCell>
            </TableRow>
          </TableHead>
          {(rows.length === 0 || areAllApproved) && (
            <TableBody>
              {!areAllApproved && (
                <TableRow>
                  <TableCell colSpan={2} align="center">
                    No approval assignments found.
                  </TableCell>
                </TableRow>
              )}
              {quoteStatus !== QuoteStatus.QUOTEAPPROVED && <TableRow>
                <TableCell colSpan={2} align="center">
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{
                      border: "1px solid #1B4A83",
                      borderRadius: "5px",
                      fontFamily: '"Noto Sans", sans-serif',
                      textTransform: "capitalize",
                      backgroundColor: "#1B4A83",
                    }}
                    onClick={handleAssignApprover}
                  >
                    Assign Approver
                  </Button>
                </TableCell>
              </TableRow>}
            </TableBody>
          )}
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell>{row.approver}</TableCell>

                <TableCell>
                  {row.iconClassName === "custom-check-icon" ? (
                    <CheckCircleIcon className={row.iconClassName} />
                  ) : row.iconClassName === "custom-cancel-icon" ? (
                    <IndeterminateCheckBoxIcon className={row.iconClassName} />
                  ) : (
                    <CloseIcon className={row.iconClassName} />
                  )}

                  {row.status}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </ApprovalWrapper>
  );
};

export default Approval;
